import { useContext } from "react";
import { ControlTargetContext } from "../state/contexts";

function useControlTarget() {
  return useContext(ControlTargetContext);
}

export default useControlTarget;
